export default __webpack_public_path__ + "static/ambient-light-06299289e0aacb8c682036e4883c927c1cfa19214d0017876007e28b9da7278d.png";